import { useOutletContext } from "react-router-dom";
import { Alert } from "@dealer-center/core-components";
import { FiltersProvider } from "./providers/FiltersProvider";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";
import { TableAttributesProvider } from "./providers/TableAttributesProvider";
import { PreferencesProvider } from "./providers/PreferencesProvider";
import { IncentivesManager } from "./IncentivesManager";
import { Locale } from "@dealer-center/ddc-core-utils";
import LABELS from "./labels.json";

export const IncentivesManagerWrapper = () => {
  const { ccUserInfo } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
    userEntity: decodedJwtAndPermissions;
  }>();
  Locale.setLabelsOnce(LABELS);

  if (!ccUserInfo.userPermissions.includes("INCENTIVESMANAGER")) {
    return (
      <Alert role="alert" sx={{ marginBottom: "16px" }} type="error">
        {Locale.getText("NO_ACCESS") as string}
      </Alert>
    );
  }
  return (
    <PreferencesProvider userInfo={ccUserInfo}>
      <FiltersProvider userInfo={ccUserInfo}>
        <TableAttributesProvider>
          <IncentivesManager />
        </TableAttributesProvider>
      </FiltersProvider>
    </PreferencesProvider>
  );
};
